import Config from '../../../config/Config'
import {
  filter,
  map,
  mergeMap,
  catchError,
  withLatestFrom,
} from 'rxjs/operators'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import * as actions from '../actions'
import * as selectors from '../selectors'
import jsCookie from 'js-cookie'
import { ofType } from 'redux-observable'

export const getJWTFromAccessToken = (action$, state$) => {
  return action$.pipe(
    filter((action) => action.type === actions.GET_JWT_FROM_ACCESS_TOKEN),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      let headers = selectors.headersSelector(state)
      if (!headers) {
        headers = action.payload
      }
      if (!headers) {
        //Don't continue if we don't have any headers to validate...
        throw new Error('Bad or Non-existent auth headers')
      }

      const settings = {
        method: 'GET',
        responseType: 'json',
        headers,
        url: `${Config.API_BASE}/v2/generate_jwt.json`,
      }
      
      return ajax(settings).pipe(
        map((payload) => {
          let payloadObj = {
            response: payload.response,
          }
          if (action.payload && action.payload.retryPayload) {
            payloadObj.retryPayload = action.payload.retryPayload
          }
          return {
            type: actions.GET_JWT_FROM_ACCESS_TOKEN_FULFILLED,
            payload: payloadObj,
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.GET_JWT_FROM_ACCESS_TOKEN_REJECTED,
            payload: payload.response,
          })
        }),
      )
    }),
    catchError((error) => {
      return of({
        type: actions.GET_JWT_FROM_ACCESS_TOKEN_REJECTED,
        payload: error,
      })
    }),
  )
}

export const saveJWTToCookies = (action$) => {
  return action$.pipe(
    ofType(actions.SAVE_JWT_TO_COOKIES),
    mergeMap((action) => {
      if (!action.payload.token || !action.payload.cookieName) {
        throw new Error('Missing action payload parameters')
      }

      jsCookie.set(action.payload.cookieName, action.payload.token, {
        domain: action.payload.domain || null,
      })

      return of({
        type: actions.SAVE_JWT_TO_COOKIES_FULFILLED,
        payload: null,
      })
    }),
    catchError((error) => {
      return of({
        type: actions.SAVE_JWT_TO_COOKIES_REJECTED,
        payload: error,
      })
    }),
  )
}

export const getStoredJWT = (action$) => {
  return action$.pipe(
    ofType(actions.GET_STORED_JWT),
    mergeMap((action) => {
      if (!action.payload.cookieName) {
        throw new Error('Missing action payload parameters')
      }

      const jwt = jsCookie.get(action.payload.cookieName)

      if (jwt) {
        return of({
          type: actions.GET_STORED_JWT_FULFILLED,
          payload: { jwt },
        })
      }

      return of({
        type: actions.GET_STORED_JWT_REJECTED,
        payload: { error: 'jwt token not available' },
      })
    }),
    catchError((error) => {
      return of({
        type: actions.GET_STORED_JWT_REJECTED,
        payload: error,
      })
    }),
  )
}

export const clearJWT = (action$) => {
  return action$.pipe(
    ofType(actions.CLEAR_JWT),
    mergeMap((action) => {
      if (!action.payload.cookieName) {
        throw new Error('Missing action payload parameters')
      }

      jsCookie.remove(action.payload.cookieName)

      return of({
        type: actions.CLEAR_JWT_FULFILLED,
        payload: null,
      })
    }),
    catchError((error) => {
      return of({
        type: actions.CLEAR_JWT_REJECTED,
        payload: error,
      })
    }),
  )
}
